<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Local</th>
        <th class="text-center tabela_borda">Estoque</th>
      </tr>
    </thead>

    <tbody>
      @for (produtoLocal of produtoLocais; track produtoLocal) {
        <tr>
          <td>{{ produtoLocal.local }}</td>
          <td class="text-center tabela_borda">{{ produtoLocal.estoque }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
